import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TransitionService } from "@uirouter/core";
import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class DeployService {
  private cache: Map<string, Observable<any>>;

  constructor(
    private http: HttpClient,
    private $transitions: TransitionService,
  ) {
    this.cache = new Map();
    this.$transitions.onStart({}, () => {
      this.cache.clear();
    });
  }

  public query(fullParams: any) {
    const [params, projectId] = splayParams(fullParams, "projectId");
    const url = `/api/v4/projects/${projectId}/deploys`;
    const cacheKey = this.queryCacheKey(url, fullParams);

    if (!this.cache.get(cacheKey)) {
      this.cache.set(
        cacheKey,
        this.http.get(url, { params }).pipe(shareReplay(1)),
      );
    }
    return this.cache.get(cacheKey);
  }

  // Similar to /deploys, but omits deploys that do not have groups.
  public groupsQuery(params: any) {
    let projectId;
    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v4/projects/${projectId}/groups/deploys`;
    return this.http.get(url, { params });
  }

  public userQuery(params: any) {
    return this.http.get("/api/v4/deploys", { params });
  }

  public get(params: any) {
    let deployId: any;
    let projectId: any;
    [params, projectId, deployId] = splayParams(
      params,
      "projectId",
      "deployId",
    );
    const url = `/api/v4/projects/${projectId}/deploys/${deployId}`;
    return this.http.get(url, { params }).pipe(map((data: any) => data.deploy));
  }

  public prev(params: any) {
    let deployId: any;
    let projectId: any;
    [params, projectId, deployId] = splayParams(
      params,
      "projectId",
      "deployId",
    );
    const url = `/api/v4/projects/${projectId}/deploys/${deployId}/prev`;
    return this.http.get(url, { params }).pipe(map((data: any) => data.deploy));
  }

  public next(params: any) {
    let deployId: any;
    let projectId: any;
    [params, projectId, deployId] = splayParams(
      params,
      "projectId",
      "deployId",
    );
    const url = `/api/v4/projects/${projectId}/deploys/${deployId}/next`;
    return this.http.get(url, { params }).pipe(map((data: any) => data.deploy));
  }

  private queryCacheKey(url: string, params: any) {
    return `q:${JSON.stringify({ url, params })}`;
  }
}
